<div attr.data-testing-id="device-{{resourceId}}-item">
  @if (device) {
    <div class="wm-devicesummary wm-m-list-row">
      <!-- first cell: Logo -->
      <div class="wm-m-device-logo-and-name wm-list-cell">
        <div class="wm-m-device-logo wm-list-cell" [pTooltip]="(device.platform !== undefined && !hasAnnotations) ? device.platform.getFullName() : ''" tooltipPosition="left">
          @if (logoSrc && hasAnnotations) {
            <div class="maintenance-info" [ngClass]="annotationStatus">
              <fa-icon icon="exclamation-triangle" [size]="'lg'" [pTooltip]="annotationString"></fa-icon>
            </div>
          }
          @if (logoSrc && hasUserAnnotations) {
            <div class="user-annotations">
              <fa-icon icon="info-circle" [size]="'lg'" [pTooltip]="userAnnotationString"></fa-icon>
            </div>
          }
          @if (logoSrc !== undefined) {
            <img [src]="logoSrc"/>
          }
          @if (logoSrc === undefined) {
            <p-progressSpinner [style]="{'width': '32px', 'height': '32px'}" class="wm-m-device-loading-spinner"></p-progressSpinner>
          }
        </div>
        <div class="wm-m-device-name-and-creation wm-list-cell">
          <wm-editable-popover class="wm-m-device-name" [displayValue]="device.name || ''" [save]="renameDevice"
            attr.data-testing-id="device-{{device.id}}-name"></wm-editable-popover>
          <div class="wm-m-device-creation-date">
            <wm-copyable-text [displayText]="shortId(device.id)" [copyText]="device.id"
              pTooltip="Copy Device Id" tooltipPosition="top"></wm-copyable-text>
          </div>
        </div>
      </div>
      <!-- third cell: all the Slot Info -->
      <div class="wm-m-device-slot-and-provider wm-list-cell">
        @if (deviceSlot !== undefined) {
          <div class="wm-m-device-slot-and-provider-text">
            <div class="wm-m-device-slot" [pTooltip]="getAutoRedeployStatus()" tooltipPosition="top">{{deviceSlot.name}}</div>
            <div class="wm-m-device-redeployment">
              <wm-copyable-text [displayText]="shortId(deviceSlot.id)" [copyText]="deviceSlot.id"
                pTooltip="Copy Slot Id" tooltipPosition="top"></wm-copyable-text>
            </div>
          </div>
        }
        @if (deviceSlot === undefined && isDeleting) {
          <div class="wm-m-device-slot-and-provider-text">
            <div class="wm-m-device-slot loading">releasing</div>
            <div class="wm-m-device-redeployment loading">Device slot</div>
          </div>
        }
        @if (deviceSlot === undefined && !isDeleting && slotLoaded) {
          <div class="wm-m-device-slot-and-provider-text">
            <div class="wm-m-device-slot loading">Slot assignment</div>
            <div class="wm-m-device-redeployment loading">pending...</div>
          </div>
        }
        @if (deviceSlot === undefined && !isDeleting && !slotLoaded) {
          <div class="wm-m-device-slot-and-provider-text">
            <div class="wm-m-device-slot loading">Loading slot...</div>
          </div>
        }
      </div>
      <!-- fourth cell: state and job-usage-possibility of the device -->
      <div class="wm-m-device-state-and-redeployment wm-list-cell">
        <fa-icon class="wm-device-state-icon" icon="server" aria-hidden="true"></fa-icon>
        <div class="wm-m-device-state-and-redeployment-text">
          @if (!isJobToggling) {
            <div class="wm-m-device-state" attr.data-testing-id="device-{{device.id}}-status">{{device.niceState}}</div>
          }
          @if (isJobToggling) {
            <div class="wm-m-device-state">{{visibleToJobs ? "disabling automation" : "enabling automation"}}</div>
          }
          <div class="wm-m-device-available">created {{device.creationTime | wmCalendarFormat}}</div>
        </div>
      </div>
      <!-- sixth cell: special conditions -->
      <div class="wm-m-device-special-condition wm-list-cell" [ngClass]="{'border-shown':  (isBusy || isJobToggling) && (otherUserInfo.length > 0 || isAutomaticallyInUse || shownReservation !== undefined)}">
        @if (isBusy || isJobToggling) {
          <fa-icon icon="sync-alt" size="lg" animation="spin" aria-hidden="true" pTooltip="Device is currently busy" tooltipPosition="top" attr.data-testing-id="device-{{device.id}}-spin"></fa-icon>
        }
      </div>
      <!-- seventh cell: status icons -->
      <div class="wm-list-cell wm-device-status">
        <fa-icon icon="robot" size="lg" [class.unavailable]="!visibleToJobs"
          [pTooltip]="visibleToJobs ? 'Available for automation' : 'Not available for automation'" tooltipPosition="top"
          aria-hidden="true" attr.data-testing-id="device-{{device.id}}-availabletojobs"></fa-icon>
        @if (deviceSlot?.isAutoRedeployEnabledForProject(projectId)) {
          <fa-icon icon="history" size="lg" pTooltip="Daily redeployment is enabled" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (otherUserInfo.length > 0 && !isReservedByAnotherUser && !isReservedByMyself) {
          <fa-icon icon="user-circle" size="lg" [pTooltip]="getAccessUsers()" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (shownReservation !== undefined && isReservedByMyself) {
          <fa-icon icon="lock" size="lg" [pTooltip]="'You currently have reserved yourself exclusive access to this Slot '+shownReservation.toNiceString()" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (shownReservation !== undefined && isReservedByAnotherUser && userHavingReservation !== undefined) {
          <fa-icon icon="ban" size="lg" [pTooltip]="'Reserved by '+userHavingReservation.name + ' ' + shownReservation.toNiceString()" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (shownReservation !== undefined && !isReservedByAnotherUser && !isReservedByMyself && userHavingReservation !== undefined) {
          <fa-icon icon="calendar-check" size="lg" [pTooltip]="'Next upcoming reservation was made by ' + userHavingReservation.name + ' '+shownReservation.toNiceString()" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (isAutomaticallyInUse) {
          <fa-icon icon="cogs" size="lg" pTooltip="Device in-use by an automation!" tooltipPosition="top" aria-hidden="true"></fa-icon>
        }
        @if (deviceSlot?.propertyBag?.updatePending === true) {
          <fa-icon icon="arrow-circle-up" size="lg" pTooltip="Update requested. Device is usable, but may go offline at any time when the update is applied." tooltipPosition="top" aria-hidden="true" attr.data-testing-id="device-summary-{{device.id}}-update-pending"></fa-icon>
        }
        @if (!!device.properties[DevicePropertyNames.MobileBridgeRunning]) {
          <img class="wm-m-device-info-logo" src="../../../../assets/img/usb.svg" [pTooltip]="getUserNameForMobileBridgeAccess(device.properties[DevicePropertyNames.MobileBridgeRunning]) | async">
        }
        @if (disconnected) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_0.svg" attr.data-testing-id="device-summary-{{device.id}}-set-disconnected"
            [pTooltip]="'Devices in this slot are simulated to appear offline.'" tooltipPosition="top">
        }
        @if (!disconnected && bandwidthLimit && bandwidthLimit.strength <= 1) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_1.svg" attr.data-testing-id="device-summary-{{device.id}}-set-bandwidth-limit"
            [pTooltip]="'Bandwidth for devices in this slot is limited to ' + bandwidthLimit.limit + '.'" tooltipPosition="top">
        }
        @if (!disconnected && bandwidthLimit && bandwidthLimit.strength === 2) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_2.svg" attr.data-testing-id="device-summary-{{device.id}}-set-bandwidth-limit"
            [pTooltip]="'Bandwidth for devices in this slot is limited to ' + bandwidthLimit.limit + '.'" tooltipPosition="top">
        }
        @if (!disconnected && bandwidthLimit && bandwidthLimit.strength === 3) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_3.svg" attr.data-testing-id="device-summary-{{device.id}}-set-bandwidth-limit"
            [pTooltip]="'Bandwidth for devices in this slot is limited to ' + bandwidthLimit.limit + '.'" tooltipPosition="top">
        }
        @if (!disconnected && bandwidthLimit && bandwidthLimit.strength === 4) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_4.svg" attr.data-testing-id="device-summary-{{device.id}}-set-bandwidth-limit"
            [pTooltip]="'Bandwidth for devices in this slot is limited to ' + bandwidthLimit.limit + '.'" tooltipPosition="top">
        }
        @if (!disconnected && bandwidthLimit && bandwidthLimit.strength >= 5) {
          <img class="wm-m-device-info-logo" src="assets/img/bandwidth/signal_5.svg" attr.data-testing-id="device-summary-{{device.id}}-set-bandwidth-limit"
            [pTooltip]="'Bandwidth for devices in this slot is limited to ' + bandwidthLimit.limit + '.'" tooltipPosition="top">
        }
        @if (packetLoss !== undefined && packetLoss.strength <= 0) {
          <img class="wm-m-device-info-logo" src="assets/img/packetloss/signal_0.svg"
            [pTooltip]="'Network connections for this device simulate ' + packetLoss.apiName + ' packet loss.'" tooltipPosition="top">
        }
        @if (packetLoss !== undefined && packetLoss.strength === 1) {
          <img class="wm-m-device-info-logo" src="assets/img/packetloss/signal_1.svg"
            [pTooltip]="'Network connections for this device simulate ' + packetLoss.apiName + ' packet loss.'" tooltipPosition="top">
        }
        @if (packetLoss !== undefined && packetLoss.strength === 2) {
          <img class="wm-m-device-info-logo" src="assets/img/packetloss/signal_2.svg"
            [pTooltip]="'Network connections for this device simulate ' + packetLoss.apiName + ' packet loss.'" tooltipPosition="top">
        }
        @if (packetLoss !== undefined && packetLoss.strength === 3) {
          <img class="wm-m-device-info-logo" src="assets/img/packetloss/signal_3.svg"
            [pTooltip]="'Network connections for this device simulate ' + packetLoss.apiName + ' packet loss.'" tooltipPosition="top">
        }
        @if (packetLoss !== undefined && packetLoss.strength >= 4) {
          <img class="wm-m-device-info-logo" src="assets/img/packetloss/signal_4.svg"
            [pTooltip]="'Network connections for this device simulate ' + packetLoss.apiName + ' packet loss.'" tooltipPosition="top">
        }
      </div>
      <!-- eighth cell: Actions that can be performed -->
      <div class="wm-m-device-actions wm-list-cell">
        <div class="wm-device-toolbar-item">
          <button pButton class="p-button-secondary custom-label" [disabled]="!isConsoleAccessible()" (click)="access()" [pTooltip]="generateConsoleAccessTooltip()" tooltipPosition="top" attr.data-testing-id="device-{{device.id}}-consolebtn">
            <fa-icon [icon]="faTv" [fixedWidth]="true"></fa-icon>
            <span class="label">Access</span>
          </button>
        </div>
<!--
  Top-level Redeploy button temporarily removed: on desktop it left a layout
  imbalance versus the mobile version, which has no equivalent top-level action.
  Until a suitable mobile action exists, redeploy is offered via the advanced
  options popup menu instead (see advancedActions in the component).
        @if (!hasReconnectProperty) {
          <div class="wm-device-toolbar-item">
            <button pButton class="p-button-text custom-label" (click)="redeploy()"
              [disabled]="belongsToDifferentProject || isReservedByAnotherUser || isBusy || isAutomaticallyInUse || !mayRedeploy || !wasDeployedManually"
              tooltipPosition="top" pTooltip="Redeploy this device" attr.data-testing-id="device-{{device.id}}-reconnect-redeploy-btn">
              <fa-icon icon="sync-alt" [fixedWidth]="true"></fa-icon>
              <span class="label">Redeploy</span>
            </button>
          </div>
        }
-->

        <div class="wm-device-toolbar-item">
          <button pButton class="p-button-text custom-label" (click)="release($event)" tooltipPosition="top" pTooltip="Release this device, clearing its slot." [disabled]="isDeleting || !mayDelete || belongsToDifferentProject || isReservedByAnotherUser" attr.data-testing-id="device-{{device.id}}-deletebtn">
            <fa-icon [icon]="faPlug" [fixedWidth]="true"></fa-icon>
            <span class="label">Release</span>
          </button>
        </div>
        <div class="wm-device-toolbar-item wm-device-toolbar-item-last">
          <button #advancedOptionsButton pButton class="p-button-text" (click)="toggleAdvancedOptions($event, advancedOptions, advancedOptionsButton)" tooltipPosition="top" pTooltip="Advanced options" attr.data-testing-id="device-{{device.id}}-advancedoptbtn">
            <fa-icon icon="bars" [fixedWidth]="true"></fa-icon>
          </button>
        </div>
        <p-popover #advancedOptions appendTo="body" [styleClass]="bandwidthOptionsVisible ? 'device-advanced-options-popover bandwidth-open' : 'device-advanced-options-popover'" ariaLabel="Advanced device options" [style]="{width: 'min(300px, calc(100vw - 32px))'}" (onShow)="alignAdvancedOptionsArrow(advancedOptions, advancedOptionsButton)" (onHide)="closeAdvancedOptions(advancedOptions)">
          <div class="wm-device-advanced-options" [class.with-bandwidth]="bandwidthOptionsVisible">
            <section class="wm-device-advanced-section wm-device-actions-section">
              <div class="wm-device-action-grid">
                @for (action of advancedActions; track action.id) {
                  <button
                      type="button"
                      class="p-button p-component p-button-text"
                      [class.p-button-text]="action.textButton && !(action.bandwidthAction && bandwidthOptionsVisible)"
                      [class.custom-label]="action.textButton && !(action.bandwidthAction && bandwidthOptionsVisible)"
                      [class.wm-device-bandwidth-action-active]="action.bandwidthAction && bandwidthOptionsVisible"
                      [class.danger]="action.danger"
                      [disabled]="action.disabled"
                      [attr.data-testing-id]="action.id"
                      (click)="executeAdvancedAction(action, advancedOptions)">
                    <fa-icon [icon]="action.icon" [fixedWidth]="true" aria-hidden="true"></fa-icon>
                    <span>{{action.label}}@if (action.bandwidthAction) { ({{bandwidthSelectionLabel}}) }</span>
                  </button>
                }
              </div>
            </section>

            <section class="wm-device-advanced-section wm-device-settings-section">
              <div class="wm-device-settings-toggles">
                <div class="wm-device-setting-row">
                  <p-toggle-switch
                      [inputId]="'device-automation-' + device.id"
                      [ngModel]="visibleToJobs"
                      [disabled]="automationToggleDisabled"
                      [attr.aria-label]="visibleToJobs ? 'Block automation' : 'Allow automation'"
                      (onChange)="setUsageByAutomatedJobs($event.checked)"></p-toggle-switch>
                  <label class="wm-device-setting-label" [for]="'device-automation-' + device.id">Automation</label>
                  @if (isJobToggling) {
                    <fa-icon icon="cog" animation="spin" aria-label="Updating automation setting"></fa-icon>
                  }
                </div>
                @if (showDailyRedeploymentToggle) {
                  <div class="wm-device-setting-row">
                    <p-toggle-switch
                        [inputId]="'device-daily-redeployment-' + device.id"
                        [ngModel]="dailyRedeploymentEnabled"
                        [disabled]="dailyRedeploymentToggleDisabled"
                        aria-label="Toggle daily redeployment"
                        (onChange)="toggleAutoRedeploymentForSlot()"></p-toggle-switch>
                    <label class="wm-device-setting-label" [for]="'device-daily-redeployment-' + device.id">Daily redeployment</label>
                  </div>
                }
              </div>

              @if (showPacketLossOptions) {
                <div class="wm-device-packet-loss">
                  <h3>Packet loss</h3>
                  <div class="wm-device-network-grid compact">
                    <button
                        type="button"
                        class="wm-device-network-tile"
                        [class.active]="!packetLoss"
                        [attr.aria-pressed]="!packetLoss"
                        (click)="simulatePacketLoss()">None</button>
                    @for (config of packetLossConfigurations; track config.apiName) {
                      <button
                          type="button"
                          class="wm-device-network-tile"
                          [class.active]="packetLoss?.apiName === config.apiName"
                          [attr.aria-pressed]="packetLoss?.apiName === config.apiName"
                          (click)="simulatePacketLoss(config)">{{config.apiName}}</button>
                    }
                  </div>
                </div>
              }
            </section>

            @if (showBandwidthOptions) {
              <section class="wm-device-advanced-section wm-device-bandwidth-section">
                <h3>Bandwidth</h3>
                <div class="wm-device-network-grid bandwidth">
                  <button
                      type="button"
                      class="p-button-text custom-label p-button p-component wm-device-network-tile"
                      [class.active]="!disconnected && !bandwidthLimit"
                      [attr.aria-pressed]="!disconnected && !bandwidthLimit"
                      (click)="selectBandwidthLimit(); hideBandwidthOptions()">
                    <span>No limit</span>
                  </button>
                  @for (config of bandwidthMenuConfigurations; track config.apiName) {
                    <button
                        type="button"
                        class="p-button-text custom-label p-button p-component wm-device-network-tile"
                        [class.active]="!disconnected && bandwidthLimit?.apiName === config.apiName"
                        [attr.aria-pressed]="!disconnected && bandwidthLimit?.apiName === config.apiName"
                        [pTooltip]="config.limit"
                        tooltipPosition="top"
                        (click)="selectBandwidthLimit(config); hideBandwidthOptions()">
                      <span>{{config.name}} ({{config.limit}})</span>
                    </button>
                  }
                  <button
                      type="button"
                      class="p-button-text custom-label p-button p-component wm-device-network-tile danger"
                      [class.active]="disconnected"
                      [attr.aria-pressed]="disconnected"
                      (click)="selectOfflineBandwidth(); hideBandwidthOptions()">
                    <span>Offline</span>
                  </button>
                </div>
              </section>
            }
          </div>
        </p-popover>
      </div>
    </div>
  }

  @if (device === undefined) {
    <div class="wm-devicesummary wm-m-list-row">
      <div class="wm-m-device-logo wm-list-cell">
        <p-progressSpinner [style]="{'width': '48px', 'height': '48px'}" class="wm-m-device-loading-spinner"></p-progressSpinner>
      </div>
      <div class="wm-m-device-name-and-provider wm-list-cell">
        <div class="wm-m-device-name">Loading device</div>
      </div>
      <div class="wm-list-cell"><!--dummy col3--></div>
      <div class="wm-list-cell"><!--dummy col4--></div>
      <div class="wm-list-cell"><!--dummy col5--></div>
      <div class="wm-list-cell"><!--dummy col6--></div>
      <div class="wm-list-cell"><!--dummy col7--></div>
    </div>
  }

  @if (device !== undefined && deviceDetailsVisible) {
    <div class="wm-list-row wm-devicesummary-list-details">
      <div class="wm-devicesummary-list-details-close-arrow">
        <fa-icon icon="caret-up" size="2x" aria-hidden="true" (click)="closeDeviceDetails()" pTooltip="Close device details" tooltipPosition="right"></fa-icon>
      </div>
      <div class="wm-devicesummary-list-details-content">
        <div class="wm-devicesummary-list-details-table">
          @for (group of getGroupedDeviceProperties(); track group.name) {
            <div class="wm-devicesummary-list-details-group">
              <div class="wm-devicesummary-list-details-group-title">{{group.name}}</div>
              <div class="wm-devicesummary-list-details-group-content">
                @for (p of group.entries; track p.fullKey) {
                  <div class="wm-devicesummary-list-details-row">
                    <div class="wm-devicesummary-list-details-entry row-desc">
                      <wm-copyable-text [displayText]="p.key" [copyText]="p.fullKey"></wm-copyable-text>
                    </div>
                    @switch (p.fullKey) {
                      @case (DevicePropertyNames.MachineBrowsers) {
                        <div class="wm-devicesummary-list-details-entry">
                          <wm-browsers-info [browsers]="browsersOfDevice"></wm-browsers-info>
                        </div>
                      }
                      @case (DevicePropertyNames.Resolution) {
                        <div class="wm-devicesummary-list-details-entry dict-value">
                          @for (item of $any(p.value) | keyvalue; track item) {
                            <div class="dict-entry">
                              <div class="label">
                                <wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text>
                              </div>
                              <div class="value">
                                <wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @case (DevicePropertyNames.ActiveVehicles) {
                        <div class="wm-devicesummary-list-details-entry active-vehicles">
                          @for (vehicle of $any(p.value); track vehicle) {
                            <div>
                              <wm-browser [displaySmall]="true" [browser]="vehicle.vehicle"></wm-browser>
                            </div>
                          }
                        </div>
                      }
                      @default {
                        @if (isObjectValue(p.value)) {
                          @if (!Array.isArray(p.value)) {
                            <div class="wm-devicesummary-list-details-entry dict-value">
                              @for (item of $any(p.value) | keyvalue; track item) {
                                <div class="dict-entry">
                                  <div class="label">
                                    <wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text>
                                  </div>
                                  <div class="value">
                                    <wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          @if (Array.isArray(p.value)) {
                            @for (entry of $any(p.value); track entry) {
                              <div class="wm-devicesummary-list-details-entry dict-value">
                                @for (item of $any(entry) | keyvalue; track item) {
                                  <div class="dict-entry">
                                    <div class="label">
                                      <wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text>
                                    </div>
                                    <div class="value">
                                      <wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          }
                        }
                        @if (!isObjectValue(p.value)) {
                          <div class="wm-devicesummary-list-details-entry">
                            <wm-copyable-text [displayText]="prettyPrintDetailValue(p.value)"></wm-copyable-text>
                          </div>
                        }
                      }
                    }
                  </div>
                }
                @if (group.name === 'webmate' && deviceCreator) {
                  <div class="wm-devicesummary-list-details-row">
                    <div class="wm-devicesummary-list-details-entry row-desc">
                      <wm-copyable-text displayText="deployed by"></wm-copyable-text>
                    </div>
                    <div class="wm-devicesummary-list-details-entry">
                      <wm-copyable-text [displayText]="deviceCreator.name + ', ' + (device.creationTime | wmCalendarFormat)"></wm-copyable-text>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (activeBrowserSession) {
            <div class="wm-devicesummary-list-details-row">
              <div class="wm-devicesummary-list-details-entry row-desc">Active browser session:</div>
              <div class="wm-devicesummary-list-details-entry">
                <span class="wm-devicesummary-list-details-show-session custom-label" (click)="openBrowserSessionViewer(activeBrowserSession.id)" attr.data-testing-id="device-{{device.id}}-active-browsersession"><span>Show Session</span> </span>
                <span class="wm-devicesummary-list-details-stop-session custom-label" (click)="stopExpedition(activeBrowserSession.id)" attr.data-testing-id="device-{{resourceId}}-stop-browsersession"><span>Stop Session</span> </span>
                <span class="wm-devicesummary-list-details-entry-browsersession-time">
                  <span class="label">started:</span> {{activeBrowserSession.optStart | wmCalendarFormat}}</span>
                </div>
              </div>
            }
            @if (oldBrowserSessions && oldBrowserSessions.length > 0) {
              @for (s of oldBrowserSessions; track s; let first = $first) {
                <div class="wm-devicesummary-list-details-row">
                  <div class="wm-devicesummary-list-details-entry row-desc">{{first ? "Previous browser sessions:" : ""}}</div>
                  <div class="wm-devicesummary-list-details-entry">
                    <span class="wm-devicesummary-list-details-show-session" (click)="openBrowserSessionViewer(s.id)"><span>Show Session</span></span>
                    <span class="wm-devicesummary-list-details-entry-browsersession-time">
                      <span class="label">started:</span> {{s.optStart | wmCalendarFormat}}
                      <span class="label">ended:</span> {{s.optEnd | wmCalendarFormat}}
                    </span>
                  </div>
                </div>
              }
            }
            <!-- TODO: add a List of all Reservations for the Slot here -->
          </div>
        </div>
      </div>
    }
  </div>
